// src/components/ui/ErrorAlert.jsx
import React from 'react';
import PropTypes from 'prop-types';

export const ErrorAlert = ({ error, onRetry }) => (
  <div className="p-4 bg-red-50 rounded-md">
    <p className="text-red-700">{error}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-2 text-sm text-red-600 hover:text-red-800"
      >
        다시 시도
      </button>
    )}
  </div>
);

// PropTypes 선언을 컴포넌트 선언 이후로 이동
ErrorAlert.propTypes = {
  error: PropTypes.string.isRequired,
  onRetry: PropTypes.func
};